import { render, staticRenderFns } from "./ReturnButton.vue?vue&type=template&id=56f7a24f&scoped=true&"
import script from "./ReturnButton.vue?vue&type=script&lang=js&"
export * from "./ReturnButton.vue?vue&type=script&lang=js&"
import style0 from "./ReturnButton.vue?vue&type=style&index=0&id=56f7a24f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f7a24f",
  null
  
)

export default component.exports